var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-tab-box",style:({marginTop:_vm.marginTop})},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:index,class:_vm.tabIndex == index ? 'common-tab-list common-tab-active' : 'common-tab-list',on:{"click":function($event){return _vm.tabClick(item, index)}}},[_vm._v(" "+_vm._s(item.tabName)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }